import React from 'react';
import { inject, observer } from 'mobx-react';
import SsoStore from '../stores/SsoStore';

interface LoggedInProps {
  ssoStore?: SsoStore;
  children: React.ReactNode;
  hard?: boolean;
}

@observer
class LoggedIn extends React.Component<LoggedInProps> {
  public static defaultProps: Partial<LoggedInProps> = {
    hard: false
  };

  public isVisible() {
    const ssoStore = this.props.ssoStore;
    return this.props.hard ? ssoStore.loggedInWithHardAuth : ssoStore.loggedIn;
  }

  public render() {
    if (this.isVisible()) {
      return <>{this.props.children}</>;
    }
    return null;
  }
}

export default inject('ssoStore')(LoggedIn);
